/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdfviewer_Unsupportedbrowsertitle3Inputs */

const en_pdfviewer_unsupportedbrowsertitle3 = /** @type {(inputs: Pdfviewer_Unsupportedbrowsertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser version isn't supported`)
};

/**
* | output |
* | --- |
* | "This browser version isn't supported" |
*
* @param {Pdfviewer_Unsupportedbrowsertitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const pdfviewer_unsupportedbrowsertitle3 = /** @type {((inputs?: Pdfviewer_Unsupportedbrowsertitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdfviewer_Unsupportedbrowsertitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_pdfviewer_unsupportedbrowsertitle3(inputs)
});
export { pdfviewer_unsupportedbrowsertitle3 as "pdfViewer_unsupportedBrowserTitle" }